// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28QI0","right":"styles_right__2pZlJ"};